'use strict';

var $ = require('jquery');

/**
 * Sends JQuery events when JSF does an ajax request
 * 
 * The events are triggered on document because according to https://api.jquery.com/Ajax_Events/
 * that is what jQuery does: "These events are triggered on the document"
 * 
 * Watch with code like this: $(document).on('a4jComplete', function(event, a4j) { ... });
 * The a4j param is an object containing the parameters that a4j sends.
 * 
 */
document.addEventListener('jsfAjaxEvent', function(event) {
	var data = event.detail;
	var fireType = data.fireType;
	$(event.target).trigger('jsfAjax' + fireType.charAt(0).toUpperCase() + fireType.substring(1), data);
});
